import { StrictMode } from 'react'; 
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find root element');

const root = createRoot(rootElement);

// Define the global onYouTubeIframeAPIReady function
// This function is called by the YouTube IFrame Player API once it has loaded.
window.onYouTubeIframeAPIReady = () => {
  console.log('main.tsx: Global onYouTubeIframeAPIReady fired. Dispatching custom event.');
  // Dispatch a custom event to signal that the YouTube API is ready
  const event = new Event('youtube-api-ready');
  window.dispatchEvent(event);
};

// Dynamically load the YouTube IFrame Player API script
// This ensures the YT global object is available and onYouTubeIframeAPIReady is called.
const tag = document.createElement('script');
tag.src = 'https://www.youtube.com/iframe_api';
const firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);


root.render(
  <StrictMode>
    <App />
  </StrictMode>
);

